exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__mainContent___2G7Dy{display:flex;justify-content:space-between}.styles__actions___1CGMP{margin-left:1.5rem}.styles__subtitle___3i7oy{color:#5a6872;font-size:.875rem}", ""]);

// Exports
exports.locals = {
	"mainContent": "styles__mainContent___2G7Dy",
	"actions": "styles__actions___1CGMP",
	"subtitle": "styles__subtitle___3i7oy"
};